import { cloneElement, useEffect, useState } from "react";
import { AnalyticsService } from "@/services/analytics.js";
import { toast } from "sonner";
import { handleError } from "@/services/errorHandler.js";
import { useNavigate, useParams } from 'react-router-dom'
import * as API from '@/services/api.js'
import { MainLoader } from '@/components/loader/MainLoader.jsx'
import { AUTH_BASE_PATH } from '@/consts/index.js'

export const BrandStrategySnapshopDataProvider = ({ children }) => {

    const { snapshotId } = useParams()
    const [snapshot, setSnapshot] = useState(null)
    const navigate = useNavigate()

    const fetchData = async () => {
        try {
            const { data } = await API.getBrandStrategySnapshot(snapshotId)
            if (!data) {
                toast.error('Brand Strategy Snapshot not found')
                navigate('/')
                return
            }
            setSnapshot(data)
        } catch (e) {
            toast.error(e.message)
            console.log(e)
            handleError(e)
            navigate(AUTH_BASE_PATH)
        }
    }

    useEffect(() => {
        AnalyticsService.page('brand-strategy-snapshot-page', { snapshotId })
        if (snapshotId) {
            fetchData()
            return
        }
        navigate('/')
    }, []);

    return (
        <div className="w-full min-h-screen bg-main-surface bg-center bg-cover bg-no-repeat bg-fixed">
            {!snapshot ? <MainLoader className="absolute w-full h-full z-10" /> : cloneElement(children, { snapshot })}
        </div>
    )

}
